import type { ReadonlyDate } from '../utils'

type Metric = Readonly<{ timestamp: ReadonlyDate, numberOfConnectedDatapoints: number, numberOfReceivedMessages: number, date: ReadonlyDate }>

export type HourlyMetric = Pick<Metric, 'numberOfConnectedDatapoints' | 'numberOfReceivedMessages' | 'timestamp'>

export type DailyMetric = Pick<Metric, 'numberOfConnectedDatapoints' | 'numberOfReceivedMessages' | 'date'>

export type Metrics = Readonly<{ hourly: readonly HourlyMetric[], daily: readonly DailyMetric[], isPortalReachable: boolean }>
